<template>
    <select
        :id="param"
        :name="param"
        v-model="val"
        class="form-control form-control-lg bg-light col-3"
    >
        <option></option>
        <option>7 days</option>
        <option>14 days</option>
        <option>21 days</option>
        <option>1 week</option>
        <option>2 weeks</option>
        <option>3 weeks</option>
        <option>30 days</option>
        <option>60 days</option>
        <option>90 days</option>
        <option>1 year</option>
        <option>lifetime</option>
    </select>
</template>

<script>
export default {
    name: "InputGuarantee",
    props: ["param", "value"],
    data: function() {
        return {};
    },

    computed: {
        val: {
            get: function() {
                return this.value;
            },
            set: function(newValue) {
                this.$parent.progress = true;
                this.$parent.update(this.param, newValue);
            },
        },
    },
};
</script>
